import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Tooltip} from "primereact/tooltip";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import {Badge} from "primereact/badge";
import {Chart} from "primereact/chart";


const MyCreditHistory = props => {
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [histories, setHistories] = useState([]);
    const [chartDialog, setChartDialog] = useState(false);
    const [chartData, setCharData] = useState({
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    "#6eb653",
                    "#a8a6a2"
                ],
                hoverBackgroundColor: [
                    "#6eb65e",
                    "#a8a6a9",
                ]
            }]
    });
    const [totalCredit, setTotalCredit] = useState(0);
    const [currentCredit, setCurrentCredit] = useState(0);
    const [usedCredit, setUsedCredit] = useState(0);

    const lightOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    };

    useEffect(() => {
        getHistories();
        getCredit();
    }, []);

    const getHistories = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/credit-history/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            showSuccess("Kredi Harcamaları Görüntülendi");
                            setHistories(data.histories);
                        } else {
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getCredit = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        // setLoadingState(true);
        axios.get('api/user-credit-percentage/', {"headers": headers, method: "GET"})
            .then(res => {
                // setLoadingState(false);
                const data = res.data;
                if (data.result) {
                    const chart_data = {
                        labels: ["Kalan Kredi", "Kullanılan Kredi"],
                        datasets: [
                            {
                                data: [data.credit, data.used_credit],
                                backgroundColor: [
                                    "#6eb653",
                                    "#a8a6a2"
                                ],
                                hoverBackgroundColor: [
                                    "#6eb65e",
                                    "#a8a6a9",
                                ]
                            }]
                    }
                    setCharData(chart_data);
                    setUsedCredit(data.used_credit);
                    setCurrentCredit(data.credit);
                    setTotalCredit(data.credit + data.used_credit);
                } else {
                    setCurrentCredit(0);
                }
            })
    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getHistoryBody = (compute_key, compute_name) => {
        const historyBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return historyBody;
    }

    const getHeader = (value) => {
        return (
            <div align="center" style={{wordBreak: 'break-all'}}>{value}</div>
        );
    }

    const chartDialogOnHide = () => {
        setChartDialog(false);
    }

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>

            <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-2 p-xl-2">
                    <Button icon="pi pi-chart-bar" label="Kredi Kullanım Oranı" className="p-button-rounded"
                            onClick={(e) => setChartDialog(true)}/>
                </div>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-8 p-xl-8"></div>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-2 p-xl-2" align="right">
                    <Button label="Mevcut Krediniz" icon="pi pi-money-bill"
                            className="p-button-rounded p-button-info"
                            disabled>
                        <Tag className="p-ml-2" severity="warning" style={{fontSize: '12px'}}
                             value={currentCredit}></Tag>
                    </Button>
                </div>
            </div>

            <div className="datatable-responsive-demo">
                <div className='card'>
                    <DataTable
                        value={histories}
                        className='p-datatable-responsive-demo'
                        paginator
                        rows={10}
                        header="KREDİ HARCAMALARIM"
                        emptyMessage="Kayıt Bulunamadı"
                    >
                        <Column field="history_type"
                                header="Harcama Türü"
                                body={getHistoryBody("history_type", "Harcama Türü")}
                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="history_time"
                                header="Harcama Zamanı"
                                body={getHistoryBody("history_time", "Harcama Zamanı")}
                                style={{textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="credit"
                                header="Harcanan Kredi"
                                body={getHistoryBody("credit", "Harcanan Kredi")}
                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="detail"
                                header="Harcama Açıklaması"
                                body={getHistoryBody("detail", "Harcama Açıklaması")}
                                style={{textAlign: 'center', width: '5.5em'}}
                        />
                        <Column field="server"
                                header="Harcama Yapılan Sunucu"
                                body={getHistoryBody("server", "Harcama Yapılan Sunucu")}
                                style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                        />
                    </DataTable>
                </div>
            </div>
            <Dialog visible={chartDialog}
                    onHide={chartDialogOnHide}
                    header="Kullanıcı Kredi Kullanım Oranı"
                    style={{width: '50%'}}
                    breakpoints={{'960px': '75%'}}
                    maximizable
                    dismissableMask
            >
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="p-d-flex p-jc-center">
                            <div className="p-grid" style={{width: "100%"}}>
                                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                    <Chart type="doughnut" data={chartData} options={lightOptions}/>
                                </div>
                                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6"
                                     style={{alignSelf: 'center'}}>
                                    <div className="p-grid">
                                        <div className="p-col-12" style={{width: '100%', wordBreak: "break-all"}}>
                                            <div className="p-grid">
                                                <div className="p-col-6">
                                                    <strong>Toplam Kredi</strong>
                                                </div>
                                                <div className="p-col-6">
                                                    {totalCredit}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12" style={{width: '100%'}}>
                                            <div className="p-grid">
                                                <div className="p-col-6">
                                                    <strong>Kalan Kredi</strong>
                                                </div>
                                                <div className="p-col-6">
                                                    {currentCredit}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-col-12" style={{width: '100%'}}>
                                            <div className="p-grid">
                                                <div className="p-col-6">
                                                    <strong>Kullanılan Kredi</strong>
                                                </div>
                                                <div className="p-col-6">
                                                    {usedCredit}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

        </div>
    );

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MyCreditHistory);


// WEBPACK FOOTER //
// ./src/pages/systemmanagement/My-CreditHistory.jsx